export default "__VITE_ASSET__50f90922__"